import objectFitImages from 'object-fit-images';
import 'picturefill';
import Helper from './helpers/helper';

window.estatico = {
	data: {},
	options: {},
	helpers: new Helper()
};

document.addEventListener('DOMContentLoaded', () => {
	'use strict';

	// see _object-fill.scss
	objectFitImages(document.querySelectorAll('.object-fill'));
});
